import { render, staticRenderFns } from "./CourseContents.vue?vue&type=template&id=bb8e3992&scoped=true&"
import script from "./CourseContents.vue?vue&type=script&lang=ts&"
export * from "./CourseContents.vue?vue&type=script&lang=ts&"
import style0 from "./CourseContents.vue?vue&type=style&index=0&id=bb8e3992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8e3992",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bb8e3992', component.options)
    } else {
      api.reload('bb8e3992', component.options)
    }
    module.hot.accept("./CourseContents.vue?vue&type=template&id=bb8e3992&scoped=true&", function () {
      api.rerender('bb8e3992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/classrooms/components/landing/CourseContents.vue"
export default component.exports